/**
 * Atelier chart palette, validated with the dataviz validator (light mode):
 * lightness band, chroma floor, CVD and normal-vision separation all pass.
 * Gold sits below 3:1 on the surface, so charts always carry direct labels
 * and a data table. Assign in this fixed order; never cycle.
 */
export const ATELIER_CATEGORICAL = ['#b8622e', '#c99a14', '#16936a', '#6c5fc7', '#cc4f7e'] as const

/** Sequential emerald ramp for progress (committed → forecast → track). */
export const ATELIER_PROGRESS = {
  committed: '#0f6b4d',
  forecast: '#5fbf97',
  track: '#ece6dc'
} as const

/** Temperature keeps its status meaning (always shown with its label). */
export const ATELIER_TEMPERATURE: Record<string, string> = {
  hot: '#3f7d4e',
  warm: '#c47a1c',
  cold: '#b5443a',
  none: '#b9b0a1'
}

export const ATELIER_INK = {
  primary: '#141414',
  secondary: '#5c574f',
  muted: '#8a847a',
  grid: '#efeae2',
  surface: '#ffffff'
} as const
